export const getProject = (id) =>
    fetch(`/api/v1/tracking-projects/${id}/`, {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
